import { useParams } from "react-router";
import { useRltWorkOrderShowQuery } from "@/services/backend/rlt/work-orders/api/work-order-api";
import { PositionsByArea } from "@/routes/processes/[processId]/rlt/work-orders/execution/[workOrderId]/treatment/_components/positions-by-area";

export function WorkOrderExecutionTreatmentRoute() {
  const { workOrderId } = useParams();
  const { data } = useRltWorkOrderShowQuery({ id: workOrderId! });

  return <PositionsByArea workOrder={data!} />;
}
